export enum TenantLogoUrlsEnum {
  seha = 'assets/images/seha-logo.png',
  ccad = 'assets/images/ccad-logo.png',
  glucare = 'assets/images/glucare-logo.png',
  uhg = 'assets/images/uhg-logo.png'
}
